"use strict";

import {schemeCategory10} from '../utils/schemeCategory10';
import * as D3Array from 'd3-array'

const width = 960;
const height = 500;
const margins = {top: 40, right: 100, bottom: 40, left: 100};

export default {
  width: width,
  height: height,
  margins: margins,
}

export const horizontalProps = {
  width: width,
  height: height,
  margins: margins,
}

export const pieProps = {
  width: width,
  height: height,
  margins: margins,
  innerRadius: 0,
  categoricalColors: schemeCategory10,
  pieSort: D3Array.descending
}
